import React, { useState, useEffect } from "react";
import "./WeeklyBreakdown.css";
import BackDrop from "../../components/BackDrop/BackDrop";
import Header from "../../components/Header/Header";
import Button from "../../components/Button/Button";
import LoadCard from "./LoadCard/LoadCard";
import AddLoadForm from "./AddLoadForm/AddLoadForm";
import Navbar from "../../components/Navbar/Navbar";
import { useNavigate } from "react-router-dom";

/**Firebase Imports**/
import {
	auth,
	db,
	getDoc,
	setDoc,
	doc,
	collection,
} from "../../firebaseConfig";
import { showError } from "../../helpers/showError";

const WeeklyBreakdown = () => {
	const navigate = useNavigate();
	const loadsRef = collection(db, "weekly_loads");

	const [showAddForm, setShowAddForm] = useState(false);
	const [loads, setLoads] = useState([]);
	const [updateLoads, setUpdateLoads] = useState(false);
	/**
	 * Main Functions
	 * **/
	useEffect(() => {
		const deleteLoads = async () => {
			if (new Date().getDay() === 0) {
				await setDoc(doc(loadsRef, auth.currentUser.uid), {
					loads: [],
				})
					.then(() => {
						//costs updated
						console.log("Loads Deleted");
					})
					.catch((error) => {
						showError(error);
					});
			}
		};
		const getInputs = async () => {
			const docSnap = await getDoc(
				doc(db, "weekly_loads", auth.currentUser.uid)
			);
			if (docSnap.exists()) {
				const loadsTemp = docSnap.data().loads;
				if (loadsTemp !== undefined) {
					setLoads(loadsTemp);
				}
			}
		};
		deleteLoads();
		getInputs();
		return () => console.log("");
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [auth.currentUser, showAddForm, updateLoads]);
	/** **/

	return (
		<div className="WeeklyBreakdown h-full w-full overflow-y-auto">
			<div className="py-8 p-3 bg-white">
				{showAddForm && <BackDrop onClick={() => setShowAddForm(false)} />}
				<Navbar backTarget={"/landing"} />
			</div>

			<div className="w-full m-0 p-3 pt-0 pb-8 top-container relative">
				<Header className={"mb-8 pt-4"} size={"medium"}>
					WEEKLY REVENUE
				</Header>

				<img
					src={require("../../images/truck.png")}
					alt="truck_image"
					className="my-12"
				/>

				<Button
					mode={"filled"}
					title={"ADD+"}
					size={"xs"}
					className={"absolute left-0 bottom-0 ml-9 translate-y-1/2"}
					onClick={() => setShowAddForm(true)}
				/>
				{showAddForm && <AddLoadForm setShowAddForm={setShowAddForm} />}
			</div>

			<div className="flex flex-wrap items-center justify-center mt-6">
				{loads.length > 0 ? (
					loads.map(({ name, rate, miles }, index) => (
						<LoadCard
							array={loads}
							updateLoads={updateLoads}
							setUpdateLoads={setUpdateLoads}
							key={index}
							index={index}
							name={name}
							rate={rate}
							miles={miles}
						/>
					))
				) : (
					<p className="w-full text-center py-12 text-lg">
						No load for this week
					</p>
				)}
			</div>

			<Button
				mode={"filled"}
				title={"CALCULATE TOTAL"}
				size={"lg-1"}
				className={"my-8"}
				onClick={() => navigate("/result")}
			/>
		</div>
	);
};

export default WeeklyBreakdown;
